<template>
  <q-page class="container" padding>
    <PageHeader
      title="Cadastrar Fornecedores"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />

    <q-form ref="myForm">
      <div class="row col-12 q-col-gutter-sm q-mt-sm">
        <div
          class="col-lg-2 col-md-3 col-sm-12 col-xs-12 text-brand-5 text-weight-bold"
        >
          Razão Social
          <q-input
            label="Digite o nome da Razão Social"
            class="input-new-design"
            dense
            outlined
            v-model="fornecedor.nome"
          />
        </div>

        <div class="col-md-2 col-sm-12 col-xs-12 text-brand-5 text-weight-bold">
          Nome Fantasia
          <q-input
            label="Digite o Nome Fantasia"
            class="input-new-design"
            dense
            outlined
            v-model="fornecedor.fantasia"
          />
        </div>

        <div class="col-md-2 col-sm-12 col-xs-12 text-brand-5 text-weight-bold">
          CNPJ
          <q-input
            class="input-new-design"
            label="Digite o CNPJ"
            dense
            outlined
            v-model="fornecedor.cnpj"
            mask="##.###.###/####-##"
          />
        </div>
        <div class="col-md-2 col-md-2">
          <p></p>
          <q-btn
            class="q-mt-sm full-width"
            label="Cadastrar"
            type="submit"
            icon="done"
            no-caps
            style="background-color: #21324a; border-radius: 8px; color: white"
            :disable="disable"
            @click.prevent="criar()"
          />
        </div>
      </div>
    </q-form>

    <div class="q-my-lg">
      <q-table
        table-header-class="bg-accent text-width-bold"
        id="customers"
        flat
        class="my-sticky-dynamic"
        :rows="listaFornecedores"
        dense
        :columns="columns"
        :rows-per-page-options="[0]"
        :loading="loading"
        :filter="filter"
      >
        <template v-slot:top-left>
          <span
            style="
              font-size: 16px;
              display: block;
              margin-left: -15px;
              color: #21324a;
            "
            >Fornecedores Cadastrados</span
          >
        </template>
        <template v-slot:no-data="props">
          <div
            v-if="props"
            style="background-color: transparent"
            class="full-width row flex-center q-gutter-sm q-mt-sm"
          >
            <q-img
              src="./../../../../assets/tabelSemDados.svg"
              style="height: 170px; width: 150px"
            />
          </div>
        </template>
        <template v-slot:top-right>
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            v-model="busca"
            placeholder="Pesquisar"
          >
            <template v-slot:append> </template>
          </q-input>
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th v-for="col in props.cols" :key="col.name" :props="props">
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr :props="props">
            <q-td class="text-left" key="nome" :props="props">
              {{ props.row.nome }}
            </q-td>
            <q-td class="text-left" key="fantasia" :props="props">
              {{ props.row.fantasia }}
            </q-td>
            <q-td class="text-left" key="cnpj" :props="props">
              {{ props.row.cnpj }}
            </q-td>

            <q-td class="text-left">
              <router-link
                :to="{
                  name: 'editarFornecedor',
                  params: { id: props.row.id },
                }"
              >
                <q-btn
                  flat
                  icon="sym_o_edit"
                  color="secondary"
                  style="margin: 0px; padding: 5px"
                  round
                ></q-btn>
              </router-link>
            </q-td>
            <q-td class="text-left">
              <q-btn
                flat
                icon="sym_o_delete"
                color="red"
                round
                style="margin: 0px; padding: 5px"
                @click="(idDelete = props.row.id), (confirmacao = !confirmacao)"
              ></q-btn>
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </div>
    <dialog-confirm-design
      mensagem="Tem certeza que deseja excluir o Fornecedor?"
      :exibir="confirmacao"
      @resultado="excluirFornecedor"
    />
  </q-page>
</template>

<script>
import { ref, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRouter } from "vue-router";
import DialogConfirmDesign from "../../../../components/DialogConfirmDesign.vue";
import PageHeader from "../../../../components/PageHeader.vue";
export default {
  components: { DialogConfirmDesign, PageHeader },
  name: "CadastrarFornecedor",
  setup() {
    const loading = ref(false);
    const paginacao = ref({
      page: 1,
      rowsPerPage: 100,
    });
    const emitir = ref({
      unidade: "",
      local: "",
      descricao: "",
      dataInicio: new Date().toLocaleString("pt-br"),
      dataTermino: new Date().toLocaleString("pt-br"),
    });
    const idDelete = ref(null);
    const confirmacao = ref(false);
    const fornecedor = ref({
      id: "",
      nome: "",
      fantasia: "",
      cnpj: "",
    });

    const busca = ref("");

    const listaFornecedores = ref([]);
    const $q = useQuasar();
    const myForm = ref(null);
    const store = useStore();
    const router = useRouter();
    let disable = ref(false);
    const columns = [
      {
        name: "nome",
        label: "Razão Social",
        align: "left",
      },
      {
        name: "fantasia",
        label: "Nome Fatasia ",
        align: "left",
      },
      {
        name: "cnpj",
        label: "CNPJ ",
        align: "left",
      },
      {
        name: "editar",
        label: "Editar",
        align: "left",
      },
      {
        name: "excluir",
        label: "Excluir",
        align: "left",
      },
    ];

    const editar = async (id) => {
      router.push({ name: "editarFornecedor", params: { id } });
    };

    let listarFornecedores = async () => {
      loading.value = true;
      let resposta = await store.dispatch("org/listarFornecedores", {
        unidadeId: emitir.value.unidade.id,
        paginacao: paginacao.value,
        search: busca.value,
      });
      listaFornecedores.value = resposta.listaFornecedores;
      paginacao.value = resposta.paginacao;
      loading.value = false;
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        emitir.value.unidade = store.state.org.unidadeData;
      }
    );

    watch(
      () => busca.value,
      () => {
        listarFornecedores();
      }
    );

    const getUnidade = () => {
      if (!store.state.org.unidadeData) {
        return;
      }
      emitir.value.unidade = store.state.org.unidadeData;
    };

    onMounted(() => {
      getUnidade();
      listarFornecedores();
    });

    let criar = async () => {
      disable.value = true;
      let sucess = await myForm.value.validate();
      if (!sucess) {
        return;
      }

      try {
        await store.dispatch("fer/criarFornecedor", {
          nome: fornecedor.value.nome,
          fantasia: fornecedor.value.fantasia,
          cnpj: fornecedor.value.cnpj,
        });

        $q.notify({
          message: "Fornecedor Cadastrado!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        reset();
        onReset();
        listarFornecedores();
      } catch (e) {
        if (e.request.status < 500) {
          for (let index in e.response.data.errors) {
            $q.notify({
              message: e.response.data.errors[index],
              color: "negative",
              actions: [
                {
                  label: "Fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
          }
        }

        if (e.request.status >= 500) {
          $q.notify({
            message: "Erro no servidor, tente novamente",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
      disable.value = false;
    };

    const onReset = async () => {
      await reset();
      myForm.value.resetValidation();
    };

    const reset = async () => {
      fornecedor.value = {};
    };

    const excluirFornecedor = async (resultado) => {
      confirmacao.value = false;
      if (resultado) {
        try {
          await store.dispatch("org/excluirFornecedor", {
            id: idDelete.value,
          });
          $q.notify({
            message: "Fornecedor excluido com sucesso.",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          listarFornecedores();
        } catch (error) {
          $q.notify({
            message: "Erro ao excluir fornecedor.",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    return {
      criar,
      editar,
      myForm,
      listaFornecedores,
      listarFornecedores,
      columns,
      emitir,
      getUnidade,
      fornecedor,
      paginacao,
      filter: ref(""),
      loading,
      busca,
      idDelete,
      confirmacao,
      disable,
      excluirFornecedor,
    };
  },
};
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

.q-table--loading thead tr:last-child th {
  top: 48px;
}
.my-sticky-dynamic {
  max-height: 450px;
}
thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:last-child th {
  top: 48px;
}
thead tr:first-child th {
  top: 0;
}
tbody tr td {
  white-space: pre-wrap;
}
.elipse {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
</style>

<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}

.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}
</style>
